/**
 * Secure Storage - Obfuscated localStorage wrapper
 */
class SecureStorage {
    constructor() {
      // Simple obfuscation salt - can be made more complex if needed
      this.salt = 'ht-linegroup-frontend';
    }
  
    // Encode data with obfuscation
    _encode(data) {
      if (data === null || data === undefined) return null;
      try {
        const jsonString = JSON.stringify(data);
        return btoa(encodeURIComponent(jsonString + this.salt));
      } catch (error) {
        console.warn('SecureStorage encode error:', error);
        return null;
      }
    }
  
    // Decode obfuscated data
    _decode(encodedData) {
      if (!encodedData) return null;
      try {
        const decoded = decodeURIComponent(atob(encodedData));
        const dataWithoutSalt = decoded.replace(this.salt, '');
        return JSON.parse(dataWithoutSalt);
      } catch (error) {
        console.warn('SecureStorage decode error:', error);
        return null;
      }
    }
  
    // Generate obfuscated key
    _obfuscateKey(key) {
      const fullEncoded = btoa(key + this.salt);
      let hash = 0;
      for (let i = 0; i < (key + this.salt).length; i++) {
        const char = (key + this.salt).charCodeAt(i);
        hash = (hash << 5) - hash + char;
        hash = hash & hash;
      }
      return `_${Math.abs(hash).toString(36)}_${fullEncoded.slice(-4)}`;
    }
  
    // Store data securely
    setItem(key, value) {
      try {
        const obfuscatedKey = this._obfuscateKey(key);
        const encodedValue = this._encode(value);
        if (encodedValue !== null) {
          localStorage.setItem(obfuscatedKey, encodedValue);
          return true;
        }
        return false;
      } catch (error) {
        console.warn('SecureStorage setItem error:', error);
        return false;
      }
    }
  
    // Retrieve stored data
    getItem(key) {
      try {
        const obfuscatedKey = this._obfuscateKey(key);
        const encodedValue = localStorage.getItem(obfuscatedKey);
        return this._decode(encodedValue);
      } catch (error) {
        console.warn('SecureStorage getItem error:', error);
        return null;
      }
    }
  
    // Remove stored data
    removeItem(key) {
      try {
        const obfuscatedKey = this._obfuscateKey(key);
        localStorage.removeItem(obfuscatedKey);
        return true;
      } catch (error) {
        console.warn('SecureStorage removeItem error:', error);
        return false;
      }
    }
  
    // Clear all storage
    clear() {
      try {
        localStorage.clear();
        return true;
      } catch (error) {
        console.warn('SecureStorage clear error:', error);
        return false;
      }
    }
  
    // Check if key exists
    hasItem(key) {
      return this.getItem(key) !== null;
    }
  }
  
  const secureStorage = new SecureStorage();
  
  export default secureStorage;
  